
	// Crea un cookie per salvare l'URL di atterraggio dell'utente
	var giaulLP = getCookie("giaulLP");
    var giaulUtmSource = getCookie("giaulUtmSource");
    var giaulUtmMedium = getCookie("giaulUtmMedium");
    var giaulUtmCampaign = getCookie("giaulUtmCampaign");
    var giaulGclid = getCookie("giaulGclid");
    var giaulRef = getCookie("giaulRef");
    if (!giaulLP) {
    	var landingPage = window.location.href;
    	var cookieName = "giaulLP";
    	var cookieValue = landingPage;
    	var expiration = new Date();
    	expiration.setTime(expiration.getTime() + (14 * 24 * 60 * 60 * 1000)); // 14 giorni
    	var cookieString = cookieName + "=" + cookieValue + ";expires=" + expiration.toUTCString() + ";path=/";
    	document.cookie = cookieString;
    }
    
    var utmSource = getURLParameter("utm_source");
    if (utmSource && !getCookie("giaulUtmSource")) {
    	var cookieName = "giaulUtmSource";
    	var cookieValue = utmSource;
    	var expiration = new Date();
    	expiration.setTime(expiration.getTime() + (14 * 24 * 60 * 60 * 1000)); // 14 giorni
    	var cookieString = cookieName + "=" + cookieValue + ";expires=" + expiration.toUTCString() + ";path=/";
    	document.cookie = cookieString;
    }
    
    var utmMedium = getURLParameter("utm_medium");
    if (utmMedium && !getCookie("giaulUtmMedium")) {
    	var cookieName = "giaulUtmMedium";
    	var cookieValue = utmMedium;
    	var expiration = new Date();
    	expiration.setTime(expiration.getTime() + (14 * 24 * 60 * 60 * 1000)); // 14 giorni
    	var cookieString = cookieName + "=" + cookieValue + ";expires=" + expiration.toUTCString() + ";path=/";
    	document.cookie = cookieString;
    }
    
    var utmCampaign = getURLParameter("utm_campaign");
    if (utmCampaign && !getCookie("giaulUtmCampaign")) {
    	var cookieName = "giaulUtmCampaign";
    	var cookieValue = utmCampaign;
    	var expiration = new Date();
    	expiration.setTime(expiration.getTime() + (14 * 24 * 60 * 60 * 1000)); // 14 giorni
    	var cookieString = cookieName + "=" + cookieValue + ";expires=" + expiration.toUTCString() + ";path=/";
    	document.cookie = cookieString;
    }
    
    var gclid = getURLParameter("gclid");
    if (gclid && !getCookie("giaulUtmSource") && !getCookie("giaulUtmMedium") && !getCookie("giaulUtmCampaign")) {
    	var cookieName = "giaulGclid";
    	var cookieValue = gclid;
    	var expiration = new Date();
    	expiration.setTime(expiration.getTime() + (14 * 24 * 60 * 60 * 1000)); // 14 giorni
    	var cookieString = cookieName + "=" + cookieValue + ";expires=" + expiration.toUTCString() + ";path=/";
    	document.cookie = cookieString;
    }

    var ref = getURLParameter("ref");
    if (ref && !getCookie("giaulUtmSource") && !getCookie("giaulUtmMedium") && !getCookie("giaulUtmCampaign")) {
    	var cookieName = "giaulRef";
    	var cookieValue = ref;
    	var expiration = new Date();
    	expiration.setTime(expiration.getTime() + (14 * 24 * 60 * 60 * 1000)); // 14 giorni
    	var cookieString = cookieName + "=" + cookieValue + ";expires=" + expiration.toUTCString() + ";path=/";
    	document.cookie = cookieString;
    }

    // Recupera il valore del cookie specificato
    function getCookie(name) {
    	var value = "; " + document.cookie;
    	var parts = value.split("; " + name + "=");
    	if (parts.length == 2) return parts.pop().split(";").shift();
    }
    
    // Recupera il valore del parametro specificato nell'URL
    function getURLParameter(name) {
    	var searchString = window.location.search.substring(1);
    	var params = searchString.split("&");
    	for (var i = 0; i < params.length; i++) {
    		var val = params[i].split("=");
    		if (val[0] == name) {
    			return val[1];
    		}
    	}
    	return null;
    }
    
    if (giaulLP === undefined) {
    	giaulLP = window.location.href;
    }
    if (giaulUtmSource === undefined) {
    	giaulUtmSource = getURLParameter("utm_source");
    }
    if (giaulUtmMedium === undefined) {
    	giaulUtmMedium = getURLParameter("utm_medium");
    }
    if (giaulUtmCampaign === undefined) {
    	giaulUtmCampaign = getURLParameter("utm_campaign");
    }
    if (giaulGclid === undefined) {
    	giaulGclid = getURLParameter("gclid");
    }
    if (giaulRef === undefined) {
    	giaulRef = getURLParameter("ref");
    }
    